import { cva, type VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  // base: comportamento comum a toda ação do site
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium " +
    "transition-all duration-200 ease-out outline-none " +
    "focus-visible:ring-2 focus-visible:ring-accent/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background " +
    "disabled:pointer-events-none disabled:opacity-50 " +
    "[&_svg]:shrink-0 [&_svg]:transition-transform [&_svg]:duration-200",
  {
    variants: {
      variant: {
        primary:
          "bg-primary text-white shadow-[0_1px_0_0_rgb(255_255_255/0.12)_inset,0_2px_6px_-2px_rgb(29_78_216/0.5)] " +
          "hover:bg-primary-hover active:scale-[0.99]",
        secondary:
          "bg-surface text-foreground border border-line " +
          "hover:border-[#c9c5b6] hover:bg-surface-2 active:scale-[0.99]",
        ghost:
          "text-muted-foreground hover:text-foreground hover:bg-foreground/[0.05]",
        link:
          "text-accent hover:text-primary-hover underline-offset-4 hover:underline",
        // usado sobre superfícies escuras (faixa de segurança, footer invertido)
        inverted:
          "bg-paper-on-ink text-ink hover:bg-white active:scale-[0.99]",
      },
      size: {
        sm: "h-9 px-4 text-sm [&_svg]:size-4",
        md: "h-11 px-6 text-sm [&_svg]:size-[18px]",
        lg: "h-[50px] px-7 text-base [&_svg]:size-5",
        icon: "size-10 [&_svg]:size-5",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  },
);

export interface ButtonProps
  extends ComponentProps<"a">,
    VariantProps<typeof buttonVariants> {}

/** Ação do site — por padrão é um link (`<a>`), já que quase tudo rola por âncora. */
export function Button({ className, variant, size, ...props }: ButtonProps) {
  return (
    <a className={cn(buttonVariants({ variant, size }), className)} {...props} />
  );
}

export { buttonVariants };
